import React, { FC } from "react";
import NewLayout from "../../components/new-ui/Layout";
import Aside from "../../components/CaseStudyComponents/Aside";
import About from "../../components/CaseStudyComponents/About";
import Impact from "../../components/CaseStudyComponents/Impact";
import RelatedCaseStudies from "../../components/CaseStudyComponents/RelatedCaseStudies";
import Signup from "../../components/CaseStudyComponents/Signup";
import Quote from "../../components/CaseStudyComponents/Quote";

import QA from "@components/CaseStudyComponents/QA";

const PropLeaf: FC = () => {
    const RELATED_CASE_STUDIES = [
        {
            id: 1,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-1.png",
            tag: "Travel & Tourism",
            title: "LivingStone Stays Relocated Their Communications From..",
            link: "/case-study/livingstone-stay",
            description:
                "Founded in 2019, LivingStone Stays is revolutionising the way people spend their leisure time - making holidays a way of life. Their platform is a one-stop ...",
        },
        {
            id: 2,
            bannerimg: "https://assets.gallabox.com/gb-home/case-study/case-study-banner-3.png",
            tag: "HR & Professional Service",
            title: "Jobstars India Deployed a Multilingual Chatbot to Handle 60%..",
            link: "/case-study/jobstars-india",
            description:
                "Founded in 2002, Jobstars is one of the leading players in the Indian recruitment ecosystem. They believe in combining their passion for people with smart investments ...",
        },
    ];

    return (
        <NewLayout
            title="PropLeaf Realty Tech - Case Study | Gallabox"
            description="PropLeaf Realty Tech increases their connect ratio with customers by 25%."
            canonical="https://gallabox.com/case-study/propleaf"
        >
            <div style={{ backgroundImage: "url('https://assets.gallabox.com/gb-home/case-study/')" }} className="mt-10">
                <div
                    style={{
                        width: "100vw",
                        // height: "65vh",
                        backgroundImage: "url('https://assets.gallabox.com/gb-home/case-study/blue-bg-pattern.png')",
                        backgroundRepeat: "no-repeat",
                    }}
                    className="grid place-items-center mt-1  md:mt-20 mb-10"
                >
                    <div className=" mx-auto m-0 ">
                        <iframe
                            className="propleaf-video-cont"
                            style={{ borderRadius: "2em" }}
                            src="https://www.youtube.com/embed/2ovO3Rkp_nc"
                            title="Customer testimonial | How Gallabox helps Real Estate firm PropLeaf Realty Tech"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            </div>
            <h1 className="hidden">PropLeaf</h1>
            <div className="max-w-md max-w-6xl mx-auto sm:max-w-max mx-auto px-5 sm:px-10 lg:px-32 mt-20">
                <div className="flex flex-col max-w-6xl mx-auto sm:flex-row gap-8">
                    <div className="basis-1/5 mx-auto ">
                        <Aside
                            data={[
                                {
                                    title: "Company",
                                    content: "PropLeaf Realty Tech",
                                },
                                {
                                    title: "Industry",
                                    content: "Real estate",
                                },
                                {
                                    title: "Employees",
                                    content: "50+",
                                },
                                {
                                    title: "Product used",
                                    content: ["WhatsApp chatbot", "Integration", "WhatsApp Broadcast", "Shared Team Inbox"],
                                },
                                {
                                    title: "Automated Chats Per Month",
                                    content: "1k+",
                                },
                                {
                                    title: "Website",
                                    link: "www.propleaf.com",
                                    content: "propleaf.com",
                                },
                            ]}
                        />
                    </div>
                    <main className="basis-4/5">
                        <About
                            aboutLogo={"https://assets.gallabox.com/gb-home/case-study/propleaf/propleaf-logo.png"}
                            aboutTitle={"PropLeaf Realty Tech"}
                            aboutContent={
                                "We are one of the top real estate brokers offering the best   properties for commercial and residential purposes. Our team assists Real Estate developers in sales & marketing and business strategy, helping them achieve an incremental sales velocity and ROI."
                            }
                        />
                        <QA
                            li={[
                                `<span class="nxt-wave-impact-para block mb-6" style="line-height: 34px;">Today WhatsApp has become an important channel for communication with our customers.</span>
                                <span class="nxt-wave-impact-para" style="line-height: 34px;">
                                    Before adopting Gallabox, we used to face challenges in terms of giving one particular number to a customer where our team can respond to them at any given point in time. There was no way for us to keep track of responses. And while our team is out of office, we aren’t able to respond to our customers other than saying “Sorry, we are out of office”. Thus we seeked a WhatsApp business API solution that will help us send instant automated responses to our customers and reduce the wait time. 
                                </span>`,
                            ]}
                            question={"What were the challenges you had before using Gallabox? "}
                        />
                        <Quote
                            quoteText={"“Using Gallabox, our connect ratio with our customers has increase by 25%”"}
                            quoteBy={"- Rajesh Katariya,"}
                            position={"Founder and CEO at PropLeaf Realty Tech"}
                            paddingx={"px-7 sm:px-10 lg:px-16"}
                        />
                        <QA
                            li={[
                                `<li class="nxt-wave-impact-para my-4">
                                After having implemented Gallabox, we are able to receive messages from customers from multiple channels but to one particular WhatsApp number. This way our team can respond to queries instantly.
                                </li>`,
                                `<li class="nxt-wave-impact-para my-4">
                                We find the chatbots very helpful as they help us in handling our regular queries. They have helped us reduce the wait time for customers.
                                </li>`,
                                `<li class="nxt-wave-impact-para my-4">
                                We use Gallabox for sending out reminders to our customers. For example, if a customer is visiting a property at 11 am, we send an automated reminder to the customer at 9 am. This way we are able to reduce the number of follow ups and improve our customer inspection rate.
                                </li>`,
                            ]}
                            question={"How is Gallabox helping you? "}
                        />
                        <QA
                            li={[
                                `<li class="nxt-wave-impact-para my-4">
                                We use WhatsApp chatbots regularly and they are most helpful during the night time. When our agents are not available, bots take care of handling inquiries from any part of the world.
                                </li>`,
                                `<li class="nxt-wave-impact-para my-4">
                                Our team uses Shared team inbox to track the responses sent out by supervisors and make sure all the queries on WhatsApp have been responded to.
                                </li>`,
                            ]}
                            question={"What are the features you use in Gallabox? "}
                        />
                        <Impact
                            impactContent={[
                                `<li class="content">
                                Using Gallabox, we make sure we do not miss out on any of the leads. 
                    </li>`,
                                `<li class="content">
                                We are able to send timely responses to leads and customers.
                </li>`,
                                `<li class="content">
                                With the help of chatbots, we are able to handle basic inquiries from customers. This helps our team connect with the customers later at a time convenient for them.
            </li>`,
                                `<li class="content">
                                Our connect ratio with customers has increased by 25%.
            </li>`,
                            ]}
                        />
                    </main>
                </div>
            </div>
            <Signup img="https://assets.gallabox.com/gb-home/case-study/Robot.png" content="Want similar results?" btn="Sign Up For A Free Trial" />
            <RelatedCaseStudies related={RELATED_CASE_STUDIES} />
        </NewLayout>
    );
};

export default PropLeaf;
